import { render, staticRenderFns } from "./releasePatient.vue?vue&type=template&id=f4d02af0&scoped=true"
import script from "./releasePatient.vue?vue&type=script&lang=js"
export * from "./releasePatient.vue?vue&type=script&lang=js"
import style0 from "./releasePatient.vue?vue&type=style&index=0&id=f4d02af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d02af0",
  null
  
)

export default component.exports